import { useContext, useMemo } from "react";
import { HMICachedDataContext } from "contexts/HMICachedDataContext/HMICachedDataContext";
import { END_OF_SHIFT_FAILURE_CODE_NAME, MEASURE_METRICS } from "constants/constants";
import { HMIContext } from "contexts/HMIContext/HMIContext";
import { ShiftOptionsEnum } from "components/ShiftDropdown/ShiftDropdown.view";
import { IEventWithHours } from "components/HMIUptimeDowntimeBar/HMIUptimeDowntimeBarInterfaces";
import { HMICarousel } from "../../../../components";
import { OverallSummarySlide, TopFiveLocationsSlide, TopFiveFailureCodesSlide } from "./slides";

export const DowntimeCarousel = () => {
    const { store } = useContext(HMICachedDataContext);
    const { shift } = useContext(HMIContext);

    const countryCode =
        store.machineCenter?.production_line.mill.country?.code ??
        store.machineCenter?.production_line.mill.corporate?.country?.code;

    const selectedShiftEvents =
        shift === ShiftOptionsEnum.current
            ? store.lastTwoShiftsEventReports?.currentShiftEventWithHours
            : store.lastTwoShiftsEventReports?.previousShiftEventWithHours;

    const downtimeEvents = useMemo(
        () =>
            selectedShiftEvents &&
            selectedShiftEvents?.reduce((acc: IEventWithHours[], event) => {
                if (
                    event.measure_metric_id === MEASURE_METRICS.DOWNTIME &&
                    event.failure_code?.code !== END_OF_SHIFT_FAILURE_CODE_NAME
                ) {
                    const pendingEditionDetails = store.editionsPending[event.event_report_id];

                    const failureType = pendingEditionDetails?.failureTypeDetails || event.failure_type;
                    const failureCode = pendingEditionDetails?.failureCodeDetails || event.failure_code;
                    const area = pendingEditionDetails?.areaDetails || event.area;
                    const functionalLocation =
                        pendingEditionDetails?.functionalLocationDetails || event.functional_location;

                    const eventDetails = {
                        ...event,
                        ...(failureType && { failure_type: failureType }),
                        ...(failureCode && { failure_code: failureCode }),
                        ...(area && failureType.is_location_specific && { area: area }),
                        ...(functionalLocation &&
                            failureType.is_location_specific && { functional_location: functionalLocation }),
                    };

                    return [...acc, eventDetails];
                }
                return acc;
            }, []),
        [selectedShiftEvents, store.editionsPending],
    );

    return (
        <HMICarousel
            slides={[
                <OverallSummarySlide downtimeEvents={downtimeEvents} countryCode={countryCode} />,
                <TopFiveLocationsSlide downtimeEvents={downtimeEvents} countryCode={countryCode} />,
                <TopFiveFailureCodesSlide downtimeEvents={downtimeEvents} countryCode={countryCode} />,
            ]}
        />
    );
};
